import UserManager from '../../services/UserManager'

// Runs on every account load, so it also resets a synced name left over from a previous session
export default function syncAccountName(currentAccount) {
  if (!currentAccount.fullName) {
    UserManager.clearAccountFullNameSynced()
    return
  }
  UserManager.markAccountFullNameSynced(currentAccount.fullName)
  if (!UserManager.getUserFullName()) {
    UserManager.setUserFullName(currentAccount.fullName, false)
  }
}
